export default __webpack_public_path__ + "static/media/Bee Vision 2018 -- Oil on Canvas with Wood Structure -- 28in x 24in.b531206c.jpg";